import React, { useCallback } from "react";
import { Tab, TabList, Tabs, TabPanel } from "react-tabs";
import { Button } from "../button";

interface DashboardTabsProps {
  tabs: { id: number; title: string }[];
  tabIndex: number;
  setTabIndex: React.Dispatch<React.SetStateAction<number>>;
  refetch?: () => void;
}

const CustomTabs = ({
  tabs,
  tabIndex,
  setTabIndex,
  refetch,
}: DashboardTabsProps) => {
  const handleTabSelection = useCallback(
    (index: number) => {
      setTabIndex(index);
      refetch?.();
    },
    [setTabIndex, refetch]
  );

  return (
    <Tabs
      selectedIndex={tabIndex}
      onSelect={(index) => handleTabSelection(index)}
      selectedTabClassName="border-b-2 border-purple-primary dark:border-white"
    >
      <TabList className="flex gap-3 flex-wrap">
        {tabs.map((item, index) => (
          <Tab key={index}>
            <Button
              type="button"
              className="px-2 pb-1 dark:text-white cursor-pointer bg-transparent shadow-none rounded-none text-purple-primary hover:bg-transparent md:text-base"
            >
              {item.title}
            </Button>
          </Tab>
        ))}
      </TabList>

      {tabs.map((_, index) => (
        <TabPanel key={index} />
      ))}
    </Tabs>
  );
};

export default React.memo(CustomTabs);
